import React from 'react';
import { Typography, Row, Col, Divider } from 'antd';
import '../../Styles/ResearchLabs.css';  // Import the CSS for styling
import AppHeader from '../../Layout/Header';
import FooterComponent from '../../Layout/Footer';
import buitemsLogo from '../../Assets/ResearchLabs/SDSSL/HostUniversities/BUITEMS-1.png';  // Replace with actual logo path
import sbkLogo from '../../Assets/ResearchLabs/SDSSL/HostUniversities/SBK-1.png';  // Replace with actual logo path
import buitemsCampus from '../../Assets/ResearchLabs/SDSSL/HostUniversities/BUITEMS-Campus.jpg';
import sbkCampus from '../../Assets/ResearchLabs/SDSSL/HostUniversities/SBK-Campus.jpg';
import ScopeSection from './SDSSL Components/ScopeSection';
import ResearchDomainsSection from './SDSSL Components/ResearchDomainSection';
import ImpactSection from './SDSSL Components/ImpactSection';
import PrincipalInvestigatorSection from './SDSSL Components/PrincipalInvestigatorSection';
import OurTeamSection from './SDSSL Components/OurTeamSection';
import SocialFeedSection from './SDSSL Components/SocialFeedSection';

const { Title } = Typography;

const SpatialDecisionSupportLab = () => {
  return (
    <>
      <AppHeader />
      <div className="spatial-lab-section" role="img" aria-label="Spatial Decision Support System Lab" />

      <section className="host-university-section">
        <div className="host-university-inner">
          <Title level={2} className="host-university-title">Host University</Title>
          <Divider className="ncgsa-divider" />
          <Row gutter={[72, 40]} align="stretch">
            <Col xs={24} md={12}>
              <article className="host-university-card">
                <div className="host-university-identity">
                  <img src={buitemsLogo} alt="BUITEMS logo" className="university-logo-img" />
                  <Title level={5} className="university-name">
                    Balochistan University of IT, Eng. and Management Sciences
                  </Title>
                </div>
                <img src={buitemsCampus} alt="Balochistan University of IT, Engineering and Management Sciences campus" className="host-university-campus" />
              </article>
            </Col>
            <Col xs={24} md={12}>
              <article className="host-university-card">
                <div className="host-university-identity">
                  <img src={sbkLogo} alt="SBK Women's University logo" className="university-logo-img" />
                  <Title level={5} className="university-name">
                    Sardar Bahadur Khan Women University (SBK)
                  </Title>
                </div>
                <img src={sbkCampus} alt="Sardar Bahadur Khan Women University campus" className="host-university-campus" />
              </article>
            </Col>
          </Row>
        </div>
      </section>
    <ScopeSection/>
    <ResearchDomainsSection/>
    <ImpactSection/>
    <PrincipalInvestigatorSection/>
    <OurTeamSection/>
    <SocialFeedSection/>
      <FooterComponent />
    </>
  );
};

export default SpatialDecisionSupportLab;
